import { Link } from "react-router-dom";
import type { IntroChecklistStep } from "../lib/overview-ops";
import { cmsStrings } from "../terminology";

type Props = {
  steps: IntroChecklistStep[];
  onDismiss: () => void;
};

export function OperatorIntroChecklist({ steps, onDismiss }: Props) {
  if (steps.length === 0) return null;
  return (
    <section
      className="intro-checklist"
      aria-label={cmsStrings.overviewUi.introChecklistAria}
      data-vt-overview-intro
    >
      <div className="intro-checklist__head">
        <h2 className="intro-checklist__title">{cmsStrings.overviewUi.introChecklistTitle}</h2>
        <button
          type="button"
          className="intro-checklist__dismiss"
          onClick={onDismiss}
        >
          {cmsStrings.overviewUi.introChecklistDismiss}
        </button>
      </div>
      <ul className="intro-checklist__list">
        {steps.map((step) => (
          <li key={step.id} className="intro-checklist__item">
            <span>{step.text}</span>
            {step.href && <Link to={step.href}>{step.linkLabel}</Link>}
          </li>
        ))}
      </ul>
    </section>
  );
}
